import { useNavigate } from "react-router-dom";
import { Card } from "@/shared/components/Card";
import styles from "./powerBillCard.module.css";
// import { Button } from "@/components/ui/Button";
import andyIcon from "@/assets/icons1/andy-icon.png";
import { FlashIcon } from "@/assets/svg/FlashIcon";
import { ArrowRightIcon } from "@/assets/svg/ArrowRightIcon";

export const PowerBillCard = ({
  navigateTo,
  selectedProperty,
}: {
  navigateTo: string;
  selectedProperty: string;
}) => {
  const navigate = useNavigate();
  return (
    // <Card className={styles.powerBillCard}>
    //   <div className={styles.powerBillCardTitle}>You are eligible for the power bill discount</div>
    //   <div className={styles.powerBillCardDescription}>
    //     You are eligible for the power bill discount
    //   </div>
    //   <Button
    //     className={styles.powerBillCardButton}
    //     onClick={() => navigate(navigateTo, { state: { selectedProperty } })}
    //   >
    //     Get Started
    //   </Button>
    // </Card>
    <Card className={styles.powerBillCard}>
      <div className={styles.powerBillTop}>
        <div className={styles.powerBillLeft}>
          <div className={styles.powerBillIcon}>
            <span className={styles.flashIconWrap}>
              <FlashIcon width={22} height={22} color="#FFFFFF" />
            </span>
          </div>

          <div className={styles.powerBillText}>
            <div className={styles.powerBillTitle}>Energy Savings</div>

            <div className={styles.powerBillDescription}>
              Better electricity rates may be available in your area. See how much you could save.
            </div>
          </div>
        </div>

        <img src={andyIcon} className={styles.powerBillMouse} alt="mouse" />
      </div>
      {/* 
      <Button
        className={styles.powerBillCardButton}
        onClick={() => navigate(navigateTo, { state: { selectedProperty } })}
      >
        <span className={styles.buttonText}>Get Started</span>

        <div className={styles.buttonIcon}>
          <ArrowRightIcon width={22} height={22} />
        </div>
      </Button> */}

      <div
        className={styles.powerBillFooter}
        onClick={() =>
          navigate(navigateTo, {
            state: { selectedProperty },
          })
        }
      >
        <span>Check Savings</span>

        <div className={styles.smallArrow}>
          <ArrowRightIcon width={16} height={16} />
        </div>
      </div>
    </Card>
  );
};
